import { t as r } from "../../../vendor-CPVnY93G.js";
const e = {
  modifierPrimary: 1,
  modifierShift: 2,
  modifierAlt: 3,
  alpha: 98,
  digit: 99,
  navigation: 100,
  command: 100,
  symbol: 100,
  numpad: 100,
  fallback: 999
}, l = r(), n = {
  ShiftLeft: "Shift",
  ShiftRight: "Shift",
  ControlLeft: "Control",
  ControlRight: "Control",
  AltLeft: "Alt",
  AltRight: "Alt",
  MetaLeft: "Meta",
  MetaRight: "Meta",
  OSLeft: "Meta",
  OSRight: "Meta"
}, o = {
  Primary: { label: l ? "Cmd" : "Ctrl", order: e.modifierPrimary },
  Control: { label: "Ctrl", order: e.modifierPrimary },
  Meta: { label: l ? "Cmd" : "Meta", order: e.modifierPrimary },
  Shift: { label: "Shift", order: e.modifierShift },
  Alt: { label: l ? "Opt" : "Alt", order: e.modifierAlt }
}, a = {
  ArrowUp: { label: "↑", order: e.navigation },
  ArrowDown: { label: "↓", order: e.navigation },
  ArrowLeft: { label: "←", order: e.navigation },
  ArrowRight: { label: "→", order: e.navigation },
  PageUp: { label: "PgUp", order: e.navigation },
  PageDown: { label: "PgDn", order: e.navigation },
  Home: { label: "Home", order: e.navigation },
  End: { label: "End", order: e.navigation }
}, d = {
  Enter: { label: "Enter", order: e.command },
  Backspace: { label: "Bksp", order: e.command },
  Tab: { label: "Tab", order: e.command },
  Space: { label: "Space", order: e.command },
  Escape: { label: "Esc", order: e.command },
  Delete: { label: "Del", order: e.command },
  Insert: { label: "Ins", order: e.command },
  CapsLock: { label: "Caps", order: e.command },
  PrintScreen: { label: "PrtScn", order: e.command },
  ScrollLock: { label: "ScrLk", order: e.command },
  Pause: { label: "Pause", order: e.command }
}, b = {
  Minus: { label: "-", order: e.symbol },
  Equal: { label: "=", order: e.symbol },
  Plus: { label: "+", order: e.symbol },
  BracketLeft: { label: "[", order: e.symbol },
  BracketRight: { label: "]", order: e.symbol },
  Backslash: { label: "\\", order: e.symbol },
  Semicolon: { label: ";", order: e.symbol },
  Quote: { label: "'", order: e.symbol },
  Backquote: { label: "`", order: e.symbol },
  Comma: { label: ",", order: e.symbol },
  Period: { label: ".", order: e.symbol },
  Slash: { label: "/", order: e.symbol },
  Tilde: { label: "~", order: e.symbol },
  Exclamation: { label: "!", order: e.symbol },
  At: { label: "@", order: e.symbol },
  Hash: { label: "#", order: e.symbol },
  Dollar: { label: "$", order: e.symbol },
  Percent: { label: "%", order: e.symbol },
  Caret: { label: "^", order: e.symbol },
  Ampersand: { label: "&", order: e.symbol },
  Asterisk: { label: "*", order: e.symbol },
  LeftParen: { label: "(", order: e.symbol },
  RightParen: { label: ")", order: e.symbol },
  Underscore: { label: "_", order: e.symbol },
  LeftBrace: { label: "{", order: e.symbol },
  RightBrace: { label: "}", order: e.symbol },
  Pipe: { label: "|", order: e.symbol },
  Colon: { label: ":", order: e.symbol },
  DoubleQuote: { label: '"', order: e.symbol },
  LessThan: { label: "<", order: e.symbol },
  GreaterThan: { label: ">", order: e.symbol },
  QuestionMark: { label: "?", order: e.symbol }
}, m = {
  NumLock: { label: "Num Lk", order: e.numpad },
  NumpadAdd: { label: "+", order: e.numpad },
  NumpadSubtract: { label: "-", order: e.numpad },
  NumpadMultiply: { label: "×", order: e.numpad },
  NumpadDivide: { label: "÷", order: e.numpad },
  NumpadDecimal: { label: ".", order: e.numpad },
  NumpadEnter: { label: "Enter", order: e.numpad },
  NumpadEqual: { label: "=", order: e.numpad },
  NumpadComma: { label: ",", order: e.numpad }
}, i = {
  ...o,
  ...a,
  ...d,
  ...b,
  ...m
};
export {
  d as COMMAND_DISPLAY_MAP,
  o as MODIFIERS_DISPLAY_MAP,
  n as MODIFIER_NORMALIZATION_MAP,
  a as NAV_DISPLAY_MAP,
  m as NUMPAD_OP_DISPLAY_MAP,
  e as ORDER,
  i as STATIC_DISPLAY_MAP,
  b as SYMBOLS_DISPLAY_MAP
};
